import { render, staticRenderFns } from "./My-progress.vue?vue&type=template&id=72053f07&scoped=true&"
import script from "./My-progress.vue?vue&type=script&lang=js&"
export * from "./My-progress.vue?vue&type=script&lang=js&"
import style0 from "./My-progress.vue?vue&type=style&index=0&id=72053f07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72053f07",
  null
  
)

export default component.exports